import { PermissionEnum } from '../../../common/permissions/permissions.Enum';
import { getGroupPermissionFactory } from '../../../common/permissions/permissions.utils';
import { getUserManagementModuleName } from './user-management.permissions';

export class PermissionsPermissions {
    static GroupName = `${getUserManagementModuleName()}.Permissions`;

    static getPermissions = getGroupPermissionFactory(PermissionsPermissions.GroupName);

    static Permissions = {
        ReadAll: PermissionsPermissions.getPermissions(PermissionEnum.READ_ALL)
    };
}
